import { useState } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";

import "./Navbar.scss";
import { images } from "../../constants";
import nav from "../../constants/nav";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <div className=" app__navbar-logo2">
          <img src={images.logoMark} alt="bbm_logo" />
          <p
            className=" sec__color"
            style={{ fontWeight: "900", fontSize: "20px" }}
          >
            BBM
          </p>
        </div>
      </div>
      <ul className="app__navbar-links">
        {nav.map((item) => (
          <li className="app__flex p-text" key={`link-${item?.value}`}>
            <div />
            <a href={`#${item?.value}`}>{item?.label}</a>
          </li>
        ))}
      </ul>

      <div className="app__navbar-menu">
        <HiMenuAlt4
          style={{ cursor: "pointer", color: "white" }}
          onClick={() => setToggle(true)}
        />

        {toggle && (
          <motion.div
            initial={{ x: 200 }}
            animate={{ x: 0 }}
            transition={{ duration: 1.05, ease: "easeOut" }}
          >
            <HiX
              style={{ cursor: "pointer", color: "white" }}
              onClick={() => setToggle(false)}
            />
            <ul>
              {["home", "about", "work", "skills", "contact"].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
